module.exports = __webpack_public_path__ + "static/img/10.505494a8.png";